var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"attendance-files-modal","hide-header":"","hide-footer":"","no-stacking":"","centered":"","size":"lg"}},[_c('iframe',{attrs:{"title":"Arquivos da consulta","src":this.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }